import Select from './Select'
import Icon from "./Icon"
export default {
    Select,
    Icon
}